import type {
  AiContextDigest,
  AiExecutionPlan,
  AiExecutionGraph,
  AiOperationEnvelope,
  AiOperationSimulation,
  AiOperationalPlan,
  AiRollbackPlan,
} from '../../../types/aiOperational'

export interface AiOperationalProposalMetadata {
  operationEnvelope?: AiOperationEnvelope
  simulation?: AiOperationSimulation
  rollback?: AiRollbackPlan
  contextDigest?: AiContextDigest
  executionPlan?: AiExecutionPlan
  executionGraph?: AiExecutionGraph
}

export const metadataFromOperationalPlan = (plan: AiOperationalPlan): AiOperationalProposalMetadata => ({
  operationEnvelope: plan.envelope,
  simulation: plan.envelope.simulation,
  rollback: plan.envelope.operations.find((operation) => operation.rollback)?.rollback,
  contextDigest: plan.envelope.contextDigest,
  executionPlan: plan.envelope.executionPlan,
  executionGraph: plan.envelope.executionGraph,
})

export const withOperationalProposalMetadata = <T extends Record<string, unknown>>(
  input: T,
  plan: AiOperationalPlan,
): T & AiOperationalProposalMetadata => ({
  ...input,
  ...metadataFromOperationalPlan(plan),
})
